import { render, staticRenderFns } from "./productBar.vue?vue&type=template&id=b231c64c&"
import script from "./productBar.vue?vue&type=script&lang=js&"
export * from "./productBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports